// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangSplatRouteImport } from './routes/$lang/$'
import { Route as LangAProposRouteImport } from './routes/$lang/a-propos'
import { Route as LangAboutRouteImport } from './routes/$lang/about'
import { Route as LangApproachRouteImport } from './routes/$lang/approach'
import { Route as LangAvisoDePrivacidadRouteImport } from './routes/$lang/aviso-de-privacidad'
import { Route as LangConditionsRouteImport } from './routes/$lang/conditions'
import { Route as LangConfidentialiteRouteImport } from './routes/$lang/confidentialite'
import { Route as LangContactRouteImport } from './routes/$lang/contact'
import { Route as LangContactoRouteImport } from './routes/$lang/contacto'
import { Route as LangCookiesRouteImport } from './routes/$lang/cookies'
import { Route as LangMethodologieRouteImport } from './routes/$lang/methodologie'
import { Route as LangMetodologiaRouteImport } from './routes/$lang/metodologia'
import { Route as LangNosotrosRouteImport } from './routes/$lang/nosotros'
import { Route as LangPrivacyRouteImport } from './routes/$lang/privacy'
import { Route as LangTerminosRouteImport } from './routes/$lang/terminos'
import { Route as LangTermsRouteImport } from './routes/$lang/terms'
import { Route as LangAnalysesIndexRouteImport } from './routes/$lang/analyses/index'
import { Route as LangAnalysesSlugRouteImport } from './routes/$lang/analyses/$slug'
import { Route as LangIndustriasIndexRouteImport } from './routes/$lang/industrias/index'
import { Route as LangIndustriasSlugRouteImport } from './routes/$lang/industrias/$slug'
import { Route as LangIndustriesIndexRouteImport } from './routes/$lang/industries/index'
import { Route as LangIndustriesSlugRouteImport } from './routes/$lang/industries/$slug'
import { Route as LangInsightsIndexRouteImport } from './routes/$lang/insights/index'
import { Route as LangInsightsSlugRouteImport } from './routes/$lang/insights/$slug'
import { Route as LangSecteursIndexRouteImport } from './routes/$lang/secteurs/index'
import { Route as LangSecteursSlugRouteImport } from './routes/$lang/secteurs/$slug'
import { Route as LangServicesIndexRouteImport } from './routes/$lang/services/index'
import { Route as LangServicesSlugRouteImport } from './routes/$lang/services/$slug'
import { Route as LangServiciosIndexRouteImport } from './routes/$lang/servicios/index'
import { Route as LangServiciosSlugRouteImport } from './routes/$lang/servicios/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LangRoute = LangRouteImport.update({
            id: '/$lang',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LangRoute
          })
const LangSplatRoute = LangSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => LangRoute
          })
const LangAProposRoute = LangAProposRouteImport.update({
            id: '/a-propos',path: '/a-propos',getParentRoute: () => LangRoute
          })
const LangAboutRoute = LangAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LangRoute
          })
const LangApproachRoute = LangApproachRouteImport.update({
            id: '/approach',path: '/approach',getParentRoute: () => LangRoute
          })
const LangAvisoDePrivacidadRoute = LangAvisoDePrivacidadRouteImport.update({
            id: '/aviso-de-privacidad',path: '/aviso-de-privacidad',getParentRoute: () => LangRoute
          })
const LangConditionsRoute = LangConditionsRouteImport.update({
            id: '/conditions',path: '/conditions',getParentRoute: () => LangRoute
          })
const LangConfidentialiteRoute = LangConfidentialiteRouteImport.update({
            id: '/confidentialite',path: '/confidentialite',getParentRoute: () => LangRoute
          })
const LangContactRoute = LangContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LangRoute
          })
const LangContactoRoute = LangContactoRouteImport.update({
            id: '/contacto',path: '/contacto',getParentRoute: () => LangRoute
          })
const LangCookiesRoute = LangCookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => LangRoute
          })
const LangMethodologieRoute = LangMethodologieRouteImport.update({
            id: '/methodologie',path: '/methodologie',getParentRoute: () => LangRoute
          })
const LangMetodologiaRoute = LangMetodologiaRouteImport.update({
            id: '/metodologia',path: '/metodologia',getParentRoute: () => LangRoute
          })
const LangNosotrosRoute = LangNosotrosRouteImport.update({
            id: '/nosotros',path: '/nosotros',getParentRoute: () => LangRoute
          })
const LangPrivacyRoute = LangPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LangRoute
          })
const LangTerminosRoute = LangTerminosRouteImport.update({
            id: '/terminos',path: '/terminos',getParentRoute: () => LangRoute
          })
const LangTermsRoute = LangTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => LangRoute
          })
const LangAnalysesIndexRoute = LangAnalysesIndexRouteImport.update({
            id: '/analyses/',path: '/analyses/',getParentRoute: () => LangRoute
          })
const LangAnalysesSlugRoute = LangAnalysesSlugRouteImport.update({
            id: '/analyses/$slug',path: '/analyses/$slug',getParentRoute: () => LangRoute
          })
const LangIndustriasIndexRoute = LangIndustriasIndexRouteImport.update({
            id: '/industrias/',path: '/industrias/',getParentRoute: () => LangRoute
          })
const LangIndustriasSlugRoute = LangIndustriasSlugRouteImport.update({
            id: '/industrias/$slug',path: '/industrias/$slug',getParentRoute: () => LangRoute
          })
const LangIndustriesIndexRoute = LangIndustriesIndexRouteImport.update({
            id: '/industries/',path: '/industries/',getParentRoute: () => LangRoute
          })
const LangIndustriesSlugRoute = LangIndustriesSlugRouteImport.update({
            id: '/industries/$slug',path: '/industries/$slug',getParentRoute: () => LangRoute
          })
const LangInsightsIndexRoute = LangInsightsIndexRouteImport.update({
            id: '/insights/',path: '/insights/',getParentRoute: () => LangRoute
          })
const LangInsightsSlugRoute = LangInsightsSlugRouteImport.update({
            id: '/insights/$slug',path: '/insights/$slug',getParentRoute: () => LangRoute
          })
const LangSecteursIndexRoute = LangSecteursIndexRouteImport.update({
            id: '/secteurs/',path: '/secteurs/',getParentRoute: () => LangRoute
          })
const LangSecteursSlugRoute = LangSecteursSlugRouteImport.update({
            id: '/secteurs/$slug',path: '/secteurs/$slug',getParentRoute: () => LangRoute
          })
const LangServicesIndexRoute = LangServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => LangRoute
          })
const LangServicesSlugRoute = LangServicesSlugRouteImport.update({
            id: '/services/$slug',path: '/services/$slug',getParentRoute: () => LangRoute
          })
const LangServiciosIndexRoute = LangServiciosIndexRouteImport.update({
            id: '/servicios/',path: '/servicios/',getParentRoute: () => LangRoute
          })
const LangServiciosSlugRoute = LangServiciosSlugRouteImport.update({
            id: '/servicios/$slug',path: '/servicios/$slug',getParentRoute: () => LangRoute
          })





const LangRouteChildren = {
  LangSplatRoute: LangSplatRoute,LangAProposRoute: LangAProposRoute,LangAboutRoute: LangAboutRoute,LangApproachRoute: LangApproachRoute,LangAvisoDePrivacidadRoute: LangAvisoDePrivacidadRoute,LangConditionsRoute: LangConditionsRoute,LangConfidentialiteRoute: LangConfidentialiteRoute,LangContactRoute: LangContactRoute,LangContactoRoute: LangContactoRoute,LangCookiesRoute: LangCookiesRoute,LangMethodologieRoute: LangMethodologieRoute,LangMetodologiaRoute: LangMetodologiaRoute,LangNosotrosRoute: LangNosotrosRoute,LangPrivacyRoute: LangPrivacyRoute,LangTerminosRoute: LangTerminosRoute,LangTermsRoute: LangTermsRoute,LangIndexRoute: LangIndexRoute,LangAnalysesSlugRoute: LangAnalysesSlugRoute,LangIndustriasSlugRoute: LangIndustriasSlugRoute,LangIndustriesSlugRoute: LangIndustriesSlugRoute,LangInsightsSlugRoute: LangInsightsSlugRoute,LangSecteursSlugRoute: LangSecteursSlugRoute,LangServicesSlugRoute: LangServicesSlugRoute,LangServiciosSlugRoute: LangServiciosSlugRoute,LangAnalysesIndexRoute: LangAnalysesIndexRoute,LangIndustriasIndexRoute: LangIndustriasIndexRoute,LangIndustriesIndexRoute: LangIndustriesIndexRoute,LangInsightsIndexRoute: LangInsightsIndexRoute,LangSecteursIndexRoute: LangSecteursIndexRoute,LangServicesIndexRoute: LangServicesIndexRoute,LangServiciosIndexRoute: LangServiciosIndexRoute
}

const LangRouteWithChildren = LangRoute._addFileChildren(LangRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,LangRoute: LangRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)